import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ErrorBoundary } from './components/ErrorBoundary';

// Pages
import LoginPage from './pages/LoginPage';
import AdminPanelPage from './pages/AdminPanelPage';
import EmailTemplatesPage from './pages/EmailTemplatesPage';
import PlatformSettingsPage from './pages/PlatformSettingsPage';
import AdminUnitReviewsPage from './pages/AdminUnitReviewsPage';
import ResendTestPage from './pages/ResendTestPage';
import PublicResendTestPage from './pages/PublicResendTestPage';
import UnitTypesPage from './pages/UnitTypesPage';
import UnitManagementPage from './pages/UnitManagementPage';
import UserManagementPage from './pages/UserManagementPage';
import InvoiceManagementPage from './pages/InvoiceManagementPage';
import ReconciliationPage from './pages/ReconciliationPage';
import EventManagementPage from './pages/EventManagementPage';
import PlaceCardTemplatesRedirect from './pages/PlaceCardTemplatesRedirect';
import CreditsReportPage from './pages/CreditsReportPage';
import GiftCreditsAllUnitsPage from './pages/GiftCreditsAllUnitsPage';
import CreditPacksPage from './pages/CreditPacksPage';
import SlickPayOrdersPage from './pages/SlickPayOrdersPage';

// Components
import ProtectedRoute from './components/auth/ProtectedRoute';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/test-email" element={<PublicResendTestPage />} />
            
            {/* Protected admin routes */}
            <Route path="/dashboard" element={<ProtectedRoute><AdminPanelPage /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><PlatformSettingsPage /></ProtectedRoute>} />
            <Route path="/email-templates" element={<ProtectedRoute><EmailTemplatesPage /></ProtectedRoute>} />
            <Route path="/unit-types" element={<ProtectedRoute><UnitTypesPage /></ProtectedRoute>} />
            <Route path="/unit-reviews" element={<ProtectedRoute><AdminUnitReviewsPage /></ProtectedRoute>} />
            <Route path="/unit-management" element={<ProtectedRoute><UnitManagementPage /></ProtectedRoute>} />
            <Route path="/user-management" element={<ProtectedRoute><UserManagementPage /></ProtectedRoute>} />
            <Route path="/invoice-management" element={<ProtectedRoute><InvoiceManagementPage /></ProtectedRoute>} />
            <Route path="/reconciliation" element={<ProtectedRoute><ReconciliationPage /></ProtectedRoute>} />
            <Route path="/event-management" element={<ProtectedRoute><EventManagementPage /></ProtectedRoute>} />
            <Route path="/resend-test" element={<ProtectedRoute><ResendTestPage /></ProtectedRoute>} />
            <Route path="/placecard-templates" element={<ProtectedRoute><PlaceCardTemplatesRedirect /></ProtectedRoute>} />
            <Route path="/credits-reports" element={<ProtectedRoute><CreditsReportPage /></ProtectedRoute>} />
            <Route path="/gift-credits-all-units" element={<ProtectedRoute><GiftCreditsAllUnitsPage /></ProtectedRoute>} />
            <Route path="/credit-packs" element={<ProtectedRoute><CreditPacksPage /></ProtectedRoute>} />
            <Route path="/slickpay-orders" element={<ProtectedRoute><SlickPayOrdersPage /></ProtectedRoute>} />
            
            {/* Redirect root to login */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            
            {/* 404 - redirect to login */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;

